import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const agree = async (params: object) => {
  return await GET({ url: Api.agree, params, showError: false })
}
